export default __webpack_public_path__ + "static/media/profileDownArrow.5b29ab88.svg";